import { css, createGlobalStyle } from 'styled-components';
import Roboto from 'src/assets/Roboto/Roboto-Regular.ttf';
import RobotoMedium from 'src/assets/Roboto/Roboto-Medium.ttf';
import RobotoBold from 'src/assets/Roboto/Roboto-Bold.ttf';
import RobotoLight from 'src/assets/Roboto/Roboto-Light.ttf';
import RobotoSlab from 'src/assets/Roboto_Slab/RobotoSlab-Regular.ttf';

const globalStyles = css`
@font-face {
  font-family: 'Roboto';
  src: url('${RobotoLight}') format('truetype');
  font-style: normal;
  font-weight: 300;
  font-display: swap;
}
@font-face {
  font-family: 'Roboto';
  src: url('${Roboto}') format('truetype');
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: 'Roboto';
  src: url('${RobotoMedium}') format('truetype');
  font-style: normal;
  font-weight: 500;
  font-display: swap;
}
@font-face {
  font-family: 'Roboto';
  src: url('${RobotoBold}') format('truetype');
  font-style: normal;
  font-weight: 700;
  font-display: swap;
}
@font-face {
  font-family: 'RobotoSlab';
  src: url('${RobotoSlab}') format('truetype');
  font-display: swap;
}

html {
  height: 100%;
}

abbr {
  text-decoration: none;
}

*, *:before, *:after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: normal !important;
  &.noscroll {
    overflow: hidden;
  }
}

.tippy-popper {
  .tippy-tooltip--regular {
    padding: 10px;
    max-width: 200px;
    background-color: #4f5568;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
    text-align: center;
  }

  &[x-placement^='top'] .arrow-small {
    border-top-color: #4f5568 !important;
  }

  &[x-placement^='right'] .arrow-small {
    border-right-color: #4f5568 !important;
  }
}

#root {
  height: 100%;
}

.slider-control-bottomcenter {
  position: relative !important;
  display: flex;
  justify-content: center;
  margin-top: 30px;
  z-index: 100;
}

.Toastify__toast {
  min-height: 48px !important;
  font-size: 12px;
  border-radius: 3px;
  box-shadow: 0 0 6px 0 rgba(77, 83, 90, 0.5);
  
  .Toastify__close-button {
    font-size: 8px;
    color: #bbbbbb;
    
    &:hover {
      color: #000000;
    }
  }
  
  &.Toastify__toast--error {
    background-color: #f65556;
  }
  
  &.Toastify__toast--info {
    color: #4b4e55;
    background-color: #ffffff;
  }
}



::-ms-clear {
  display: none;
}

${window.location.href === 'http://www.lvh.me:3000/auth/sign_in' ? '#react-refresh-overlay { display: none;}' : ''}
`;

export default createGlobalStyle`
${globalStyles}
`;
